// extracted by mini-css-extract-plugin
export var quoteWrapper = "quote-module--quote-wrapper--1ZUwm";
export var photo = "quote-module--photo--3oqR2";
export var text = "quote-module--text--2ob_H";
export var quoteText = "quote-module--quote-text--1s7QA";
export var name = "quote-module--name--13pRj";
export var title = "quote-module--title--1T1SA";
export var noPhoto = "quote-module--no-photo--13__C";